import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { NavDropdown } from './menu-components';

import { faTools, faLifeRing, faCog, faBook, faCogs, faChartLine, faFileAlt, faUsers } from '@fortawesome/free-solid-svg-icons';

const paramsMenuItemsAuthenticated = (
  <>
    <MenuItem icon={faLifeRing} to="/support" data-cy="supportItem">
      Supports
    </MenuItem>
    <MenuItem icon={faCog} to="/configuration" data-cy="configItem">
      Réglages
    </MenuItem>
    <MenuItem icon={faFileAlt} to="/admin/docs" data-cy="docsItem">
      API
    </MenuItem>
    <MenuItem icon={faCogs} to="/admin/configuration" data-cy="docsItem">
      Configuration
    </MenuItem>
    <MenuItem icon={faChartLine} to="/admin/metrics" data-cy="docsItem">
      Metriques
    </MenuItem>
    <MenuItem icon={faFileAlt} to="/admin/logs" data-cy="docsItem">
      Logs
    </MenuItem>
    <MenuItem icon={faUsers} to="/admin/user-management" data-cy="docsItem">
      User Management
    </MenuItem>
  </>
);

export const ParamsMenu = ({ isAuthenticated = false }) => (
  <NavDropdown icon={faTools} name="Paramètres" id="account-menu" data-cy="accountMenu">
    {isAuthenticated && paramsMenuItemsAuthenticated}
  </NavDropdown>
);

export default ParamsMenu;
